import { render, staticRenderFns } from "./company.vue?vue&type=template&id=5d76e6ec&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=5d76e6ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d76e6ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d76e6ec')) {
      api.createRecord('5d76e6ec', component.options)
    } else {
      api.reload('5d76e6ec', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=5d76e6ec&scoped=true", function () {
      api.rerender('5d76e6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/units/components/company/company.vue"
export default component.exports